export const enum PropertyContactedIdbStatechartEvent {
  synced = 'synced',
  sync = 'sync',
  loadAllSuccess = 'loadAllSuccess',
  loadAll = 'loadAll',
}
